import React from 'react';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '../../../components/ui/dialog';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../../components/ui/select';
import { TiptapEditor } from './TiptapEditor';
import { EXPIRY_OPTIONS } from './documentConstants';

export const EditTemplateDialog = ({
  open,
  onOpenChange,
  editTitle,
  setEditTitle,
  editContent,
  setEditContent,
  editExpiresInDays,
  setEditExpiresInDays,
  saving,
  onSave,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto">
      <DialogHeader>
        <DialogTitle>Edit Template</DialogTitle>
        <DialogDescription className="sr-only">Edit Template dialog. Use the form below to continue.</DialogDescription>
      </DialogHeader>
      <div className="space-y-4">
        <div className="grid grid-cols-2 gap-4">
          <div>
            <Label>Title</Label>
            <Input
              value={editTitle}
              onChange={(e) => setEditTitle(e.target.value)}
              data-testid="template-title-input"
            />
          </div>
          <div>
            <Label>Expiration Period</Label>
            <Select value={editExpiresInDays || 'none'} onValueChange={setEditExpiresInDays}>
              <SelectTrigger data-testid="edit-expires-select">
                <SelectValue placeholder="No expiration" />
              </SelectTrigger>
              <SelectContent>
                {EXPIRY_OPTIONS.map((opt) => (
                  <SelectItem key={opt.value} value={opt.value}>{opt.label}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </div>
        <div>
          <Label>Content</Label>
          {open && <TiptapEditor content={editContent} onChange={setEditContent} />}
        </div>
      </div>
      <DialogFooter className="mt-4">
        <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
        <Button
          className="bg-amber-500 hover:bg-amber-600 text-white"
          onClick={onSave}
          disabled={saving}
          data-testid="save-template-btn"
        >
          {saving ? 'Saving...' : 'Save Template'}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
